import React from "react";
import "./TermsAndConditionsPromo.css";

const TermsAndConditionsPromo = () => {
  return (
    <div className="terms-container">
      <h1 className="terms-title">
        📜 TERMO DE CONDIÇÕES E REGULAMENTO DA PROMOÇÃO “MARATONA DE PRÊMIOS
        SETTE FIBRA”
      </h1>

      <h2>I. OBJETO</h2>
      <p>
        1.1. A promoção “Maratona de Prêmios Sette Fibra” é instituída pela
        SETTE TELECOM LTDA., inscrita no CNPJ sob o nº 12.041.618/0001-89,
        doravante denominada “Sette Fibra”, e consiste na concessão de condições
        comerciais especiais e na participação em sorteio de prêmios, válida
        entre <strong>01/10/2025 e 18/12/2025</strong>, destinada a:
      </p>
      <ul>
        <li>
          Novos clientes que contratarem plano dentro da área de cobertura e
          disponibilidade técnica;
        </li>
        <li>
          Clientes já existentes que realizarem upgrade ou renovação de plano no
          mesmo período.
        </li>
      </ul>

      <h2>II. CONDIÇÕES COMERCIAIS</h2>
      <p>
        2.1. Durante o período promocional, o plano de{" "}
        <strong>1 GIGA (500 + 500 Mega)</strong>
        será ofertado por{" "}
        <strong>R$ 99,90 (noventa e nove reais e noventa centavos) </strong>
        mensais, até o 12º (décimo segundo) mês de contrato, desde que o
        pagamento ocorra até a data de vencimento.
      </p>
      <p>
        2.2. O valor nominal regular do plano é de <strong>R$ 119,90</strong>{" "}
        por mês, aplicável a pagamentos em atraso ou após o término do período
        promocional de 12 meses.
      </p>
      <p>
        2.3. Clientes atuais poderão aderir mediante upgrade de plano ou
        renovação promocional, sujeitos à análise de elegibilidade e às
        condições de fidelização vigentes.
      </p>

      <h2>III. BENEFÍCIO DE STREAMING GRATUITO</h2>
      <p>
        3.1. Novos clientes que aderirem ao plano promocional terão direito a{" "}
        <strong>3 (três) meses gratuitos</strong> de acesso a um serviço de
        streaming à sua escolha (HBO Max ou Disney+, modalidade com anúncios).
      </p>
      <p>
        3.2. O período gratuito será contado da ativação do serviço e
        proporcional à data de adesão.
      </p>
      <p>
        3.3. Encerrado o período de gratuidade, o acesso será automaticamente
        suspenso, sem qualquer cobrança, cabendo ao cliente optar pela
        contratação do serviço junto à Sette Fibra pelo valor vigente em tabela.
      </p>
      <p>
        3.4. Para clientes existentes, a concessão do benefício estará sujeita à
        análise interna no momento do upgrade ou renovação.
      </p>

      <h2>IV. PARTICIPAÇÃO NO SORTEIO</h2>
      <p>
        4.1. Concorrerão automaticamente aos prêmios da “Maratona de Prêmios” os
        clientes que atenderem às seguintes condições:
      </p>
      <ul>
        <li>
          Novos clientes com contrato ativado durante o período promocional;
        </li>
        <li>
          Clientes existentes que realizarem upgrade de plano ou renovação
          promocional para o plano de 1 GIGA;
        </li>
        <li>Contratos ativos e adimplentes até as 18h00 do dia 18/12/2025.</li>
      </ul>
      <p>
        4.2. Cada contrato elegível corresponderá a{" "}
        <strong>01 (um) cupom eletrônico </strong>
        para o sorteio.
      </p>

      <h2>V. INSTALAÇÃO</h2>
      <p>
        5.1. A instalação será <strong>gratuita</strong> para cadastros
        aprovados conforme critérios técnicos objetivos, como viabilidade de
        rede e endereço dentro da área de cobertura.
      </p>
      <p>
        5.2. Em casos em que haja necessidade de recursos adicionais (ex.:
        infraestrutura especial, segunda visita ou deslocamento em área de
        difícil acesso), poderá ser cobrada taxa de instalação, comunicada
        previamente ao cliente.
      </p>

      <h2>VI. VIGÊNCIA DA PROMOÇÃO</h2>
      <p>
        6.1. A promoção terá validade de{" "}
        <strong>01/10/2025 a 18/12/2025</strong>.
      </p>
      <p>
        6.2. Após esta data, prevalecerão as condições comerciais vigentes da
        Sette Fibra.
      </p>

      <h2>VII. FIDELIDADE CONTRATUAL</h2>
      <p>
        7.1. A adesão à promoção implica contrato com fidelidade mínima de
        <strong>12 (doze) meses</strong>.
      </p>
      <p>
        7.2. Em caso de rescisão antecipada por iniciativa do cliente, será
        aplicada multa proporcional ao período restante, limitada ao valor dos
        benefícios concedidos (descontos ou isenção de taxa de instalação), nos
        termos da regulamentação da ANATEL.
      </p>

      <h2>VIII. CANCELAMENTO</h2>
      <p>
        8.1. O cancelamento poderá ser solicitado a qualquer momento pelos
        canais oficiais da Sette Fibra, observando-se:
      </p>
      <ul>
        <li>
          Durante o período de fidelidade: aplicação de multa proporcional,
          conforme cláusula 7.2;
        </li>
        <li>
          Após o término da fidelidade: cancelamento sem ônus, com processamento
          imediato, conforme prazos legais.
        </li>
      </ul>

      <h2>IX. REGULAMENTO DO SORTEIO</h2>
      <p>
        9.1. <strong>Período de participação</strong>
      </p>
      <ul>
        <li>Início: 00h00 de 01/10/2025</li>
        <li>Encerramento: 18h00 de 18/12/2025</li>
        <li>
          Sorteio: 19/12/2025, em transmissão ao vivo pelo perfil oficial da
          Sette Fibra no Instagram.
        </li>
      </ul>
      <p>
        9.2. <strong>Critérios de elegibilidade</strong>
      </p>
      <ul>
        <li>
          Clientes novos (contrato de adesão) ou existentes (contrato de
          renovação promocional);
        </li>
        <li>
          Contrato ativado ou renovado entre 01/10/2025 e 18/12/2025, até 18h00;
        </li>
        <li>
          Situação financeira adimplente até 18/12/2025, às 18h00. Contratos
          inadimplentes, suspensos ou cancelados serão automaticamente
          excluídos.
        </li>
      </ul>
      <p>
        9.3. <strong>Mecânica</strong>
      </p>
      <ul>
        <li>Cada contrato elegível = 01 (um) cupom eletrônico.</li>
        <li>
          O mesmo CPF/CNPJ pode participar com múltiplos contratos, desde que
          todos estejam adimplentes.
        </li>
        <li>Cada cliente poderá ser sorteado apenas uma vez.</li>
      </ul>
      <p>
        9.4. <strong>Prêmios (ordem do sorteio)</strong>
      </p>
      <ol>
        <li>1º – Fone de Ouvido JBL</li>
        <li>2º – Caixa de Som JBL Charge 3</li>
        <li>3º – Smartwatch</li>
        <li>4º – Air Fryer</li>
        <li>5º – Dispositivo Alexa</li>
        <li>6º – Forno Elétrico</li>
        <li>7º – TV 50’’</li>
      </ol>
      <p>
        9.5. <strong>Metodologia</strong>
      </p>
      <ul>
        <li>
          Em 18/12/2025, será gerada lista oficial de elegíveis, auditada e
          assinada.
        </li>
        <li>
          Em 19/12/2025, lista será carregada na plataforma www.sorteio.com.
        </li>
        <li>
          Sorteio transmitido ao vivo, conduzido por 2 representantes
          (apresentador + auditor).
        </li>
        <li>Resultados registrados em planilha e divulgados imediatamente.</li>
      </ul>
      <p>
        9.6. <strong>Divulgação dos resultados</strong>
      </p>
      <ul>
        <li>Ao vivo durante a transmissão;</li>
        <li>
          Posteriormente em site, Instagram (feed e stories) e banner na sede.
        </li>
      </ul>
      <p>
        9.7. <strong>Entrega dos prêmios</strong>
      </p>
      <ul>
        <li>Prazo: até 30 dias corridos a partir de 20/12/2025.</li>
        <li>Local: sede da Sette Fibra, em Anápolis/GO.</li>
        <li>
          Documentos: RG/CPF ou CNH, comprovante de residência e cópia do
          contrato/fatura.
        </li>
        <li>
          Retirada por representante: somente com procuração com firma
          reconhecida.
        </li>
        <li>
          Prêmios pessoais e intransferíveis, não conversíveis em dinheiro.
        </li>
      </ul>
      <p>
        9.8. <strong>Autorização de uso de imagem</strong>
      </p>
      <ul>
        <li>
          Ao retirar o prêmio, o ganhador poderá autorizar, por termo
          específico, o uso de imagem/voz pela Sette Fibra, para divulgação da
          campanha e futuras ações institucionais, pelo prazo de 5 anos, em
          qualquer mídia.
        </li>
        <li>A recusa em autorizar não impedirá a entrega do prêmio.</li>
      </ul>
      <p>
        9.9. <strong>Disposições gerais</strong>
      </p>
      <ul>
        <li>Prêmios não podem ser convertidos em dinheiro ou crédito.</li>
        <li>
          Tributos eventualmente incidentes são de responsabilidade do
          contemplado.
        </li>
        <li>A participação implica aceitação integral deste regulamento.</li>
        <li>
          O sorteio é de caráter exclusivamente promocional, não vinculado à
          Loteria Federal.
        </li>
        <li>
          Casos omissos serão resolvidos pela Sette Fibra, observando a
          legislação aplicável.
        </li>
      </ul>

      <h2>X. CONDIÇÕES GERAIS</h2>
      <p>
        10.1. A promoção é válida exclusivamente para a área de cobertura da
        Sette Fibra e está sujeita à viabilidade técnica.
      </p>
      <p>
        10.2. A Sette Fibra reserva-se o direito de alterar ou encerrar a
        promoção a qualquer momento, mediante comunicação prévia, respeitados os
        direitos adquiridos pelos consumidores já contratados.
      </p>
      <p>
        10.3. O tratamento dos dados pessoais coletados para a presente promoção
        observará a Lei Geral de Proteção de Dados (Lei 13.709/2018), conforme
        Política de Privacidade da Sette Fibra, disponível em seu site oficial.
      </p>
      <p>
        10.4. Aplicam-se, subsidiariamente, as disposições do Código de Defesa
        do Consumidor.
      </p>
    </div>
  );
};

export default TermsAndConditionsPromo;
